import { Navigate, useLocation } from 'react-router-dom';
import { getSession } from '../auth';
import { getRequiredModule, hasModuleAccess } from '../utils/moduleAccess';
import Colors from "../theme/colors";

function AccessDenied({ module }) {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            flexDirection: 'column',
            gap: '16px',
            padding: '24px'
        }}>
            <div style={{ fontSize: '64px', marginBottom: '16px' }}>🔒</div>
            <h2>Access Denied</h2>
            <p style={{ textAlign: 'center', maxWidth: '500px', color: Colors.neutralGray1 }}>
                You don't have permission to access this page.
                {module && ` Required module: ${module}`}
            </p>
            <button
                onClick={() => window.history.back()}
                style={{
                    padding: '12px 24px',
                    backgroundColor: '#3498db',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    marginTop: '16px'
                }}
            >
                Go Back
            </button>
        </div>
    );
}

export default function ProtectedRoute({ children }) {
    const session = getSession();
    const location = useLocation();
    if (!session) return <Navigate to="/" replace />;
    if (!hasModuleAccess(location.pathname)) {
        return <AccessDenied module={getRequiredModule(location.pathname)} />;
    }
    return children;
}
